'use es6';

import { Map as ImmutableMap, Record } from 'immutable';
import ModalOverrides from './ModalOverrides';
const DEFAULTS = {
  adsPanelOpen: false,
  errors: ImmutableMap(),
  modalOverrides: new ModalOverrides(),
  openModalName: null,
  socialComposerOpen: false,
  socialComposerParams: ImmutableMap()
};
export default class ModalsDisplay extends Record(DEFAULTS) {
  static fromJS({
    modalOverrides,
    openModalName
  }) {
    return new ModalsDisplay({
      modalOverrides: modalOverrides || DEFAULTS.modalOverrides,
      openModalName
    });
  }
}